// extracted by mini-css-extract-plugin
export default {"title":"x--z","warning":"y--z","sizeOptionsLegendText":"z--z"};